import { render, staticRenderFns } from "./RoundList.vue?vue&type=template&id=55ef94ca&scoped=true&"
import script from "./RoundList.vue?vue&type=script&lang=js&"
export * from "./RoundList.vue?vue&type=script&lang=js&"
import style0 from "./RoundList.vue?vue&type=style&index=0&id=55ef94ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ef94ca",
  null
  
)

export default component.exports